module.exports = __webpack_public_path__ + "img/banner_shrz.e86f493b.png";